import React from 'react';
import { COLORS } from '../../../styles/tokens';
import NewOrderIcon from './NewOrderIcon';

// «Legg til betalingskort»: vises når bestilleren må ha lagret kort før publisering.
// Selve kortoppsettet (PaymentSetup) sendes inn som children og vises når `open`.
export default function CardPrompt({ open, onAdd, children }) {
  return (
    <div style={styles.box}>
      <div style={styles.row}>
        <span style={{ color: COLORS.brandPanel, display: 'flex' }}><NewOrderIcon name="card" size={22} /></span>
        <div style={{ flex: 1 }}>
          <div style={styles.title}>Legg til betalingskort</div>
          <div style={styles.sub}>
            {open
              ? 'Legg til et betalingskort for å publisere oppdraget.'
              : 'Kort trengs før du kan publisere.'}
          </div>
        </div>
        {!open && <button type="button" onClick={onAdd} style={styles.btn}>Legg til</button>}
      </div>
      {open && <div style={{ marginTop: 10 }}>{children}</div>}
    </div>
  );
}

const styles = {
  box: { background: COLORS.warningBg, border: `1px solid ${COLORS.accent}`, borderRadius: 16, padding: 14 },
  row: { display: 'flex', alignItems: 'center', gap: 12 },
  title: { fontWeight: 700, fontSize: 14, color: COLORS.textDark },
  sub: { fontSize: 12, color: COLORS.textMid },
  btn: { background: COLORS.brandPanel, color: '#fff', border: 'none', borderRadius: 99, padding: '8px 14px', fontWeight: 700, fontSize: 13, cursor: 'pointer' },
};
